


























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { API_URL } from "../global";
import { pageDataType, SmoothScrollType, MainMenuItem } from "../types";
import BasicPage from "./BasicPage.vue";
import HomePage from "./HomePage.vue";
import ProjectPage from "./ProjectPage.vue";
import ProjectDetailsPage from "./ProjectDetailsPage.vue";
import ContactPage from "./ContactPage.vue";
import LandownersPage from "./LandownersPage.vue";
// import { SmoothScroll } from "../smscroll";
// import {
//     SmoothScroll
// } from "../common";
// import {
//     MbSmoothScroll
// } from "../mbcommon";
import { sociallinkItem } from "../types";
import { Nav } from "../nav";
import { mobileMenu } from "../mobileMenu";
import {
  FETCH_MAIN_MENU,
  FETCH_PROJECT_SETTINGS,
  FETCH_SOCIAL,
} from "../store/actions.names";
import axios from "axios";
import { ADD_ANIMATION } from "../store/mutations.names";
import {
  TimelineMax,
  Power1,
  Power2,
  Cubic,
  Power4,
  TweenMax,
  Elastic,
  Linear,
  Back,
  SlowMo,
  Sine,
  Expo,
  Power3,
} from "gsap";
import {
  SET_PRELOADER_LOADED,
  SET_MENU_LOADED,
} from "../store/mutations.names";
import { HOST } from "../global";
import { PROJECT_SETTINGS } from "../store/getters.names";
@Component({
  name: "Page",
  components: {
    HomePage,
    BasicPage,
    ProjectPage,
    ProjectDetailsPage,
    contact_form: ContactPage,
    image_text_with_richtext: LandownersPage,
  },
  methods: {
    reloadPage() {
      this.$router.go((this as any).$router.currentRoute);
    },
  },
})
export default class Page extends Vue {
  @Getter("mainMenu") public mainMenu!: MainMenuItem[];
  @Getter(PROJECT_SETTINGS) public projectSettings!: any;
  @Getter("sociallink") public sociallink!: sociallinkItem[];
  @Getter("pageData") public pageData!: pageDataType;
  @Getter("pageType") public pageType!: string | null;
  @Action(FETCH_MAIN_MENU) public [FETCH_MAIN_MENU]: any;
  @Action(FETCH_PROJECT_SETTINGS) public [FETCH_PROJECT_SETTINGS]: any;
  @Mutation(SET_PRELOADER_LOADED) public [SET_PRELOADER_LOADED]: any;
  @Mutation(SET_MENU_LOADED) public [SET_MENU_LOADED]: any;
  @Getter("isPreloaderLoaded") public preloaderLoaded!: boolean;
  @Getter("isMenuLoaded") public MenuLoaded!: boolean;
  @Mutation(ADD_ANIMATION) public [ADD_ANIMATION]: any;
  @Action(FETCH_SOCIAL) public [FETCH_SOCIAL]: any;
  public nav: any | null = null;
  public pageLoaded: boolean = false;
  public projects: any = [];
  ItemIndex: any | null = null;
  public HOST: string = HOST;
  public isProject: boolean = false;
  scroll: any | null = null;
  mobileMenuToggle: boolean = false;
  public animated: boolean = false;
  public isDrop: boolean = false;
  get pageTitle(): string {
    return this.pageData ? `${this.pageData.title} | RDL` : "RDL";
  }
  public refOffset = 0;
  public bannerHeight = 80;
  @Prop() public hashData!: string | null;
  public hData: string | null = "";
  mbtl: any | null = null;
  comp: string | null = "completed";
  ong: string | null = "ongoing";
  upc: string | null = "upcoming";
  toggleDropmenu() {
    this.isDrop = !this.isDrop;
  }

  @Watch("$route", { immediate: true })
  route() {
    if (this.isDrop == true) {
      this.isDrop = false;
    }

    (this as any).ItemIndex = null;
  }
  selectIndex(idx: any) {
    (this as any).ItemIndex = idx;
  }

  public spanify(string: string) {
    return string
      .split("")
      .map((val) => {
        return `<span>${val}</span>`;
      })
      .join("");
  }
  public dropMenu() {
    let dropmenutl = new TimelineMax();
    dropmenutl.staggerFrom(
      ".dropdown-menu .list-menu .list-item .text-cont .txt-field .word",
      1,
      {
        y: 50,
        opacity: 0,
        left: 30,
        ease: Expo.easeOut,
        clearProps: "all",
      },
      0.03
    );
  }

  // public goToPage(url: string) {
  //   this.$router.push(url);
  // }
  public mbtimeline() {
    let menutl = new TimelineMax({
      paused: true,
    })
      .from(".mblists ul .menu-item .drop-icon", 0.5, {
        opacity: 0,
        y: 30,
        delay: 1,
        ease: Expo.easeOut,
      })
      .staggerFrom(
        ".menu ul li a span",
        1,
        {
          y: 50,
          opacity: 0,
          left: 30,
          ease: Expo.easeOut,
        },
        0.03
      );
    (this as any).menutl = menutl;
  }

  public mobileMenu() {
    let mbtl = new TimelineMax({
      paused: true,
    })

      .set("body", {
        position: "fixed",
        clearProps: "all",
      })
      .fromTo(
        ".overlay",
        0,
        {
          visibility: "hidden",
        },
        {
          visibility: "visible",
        }
      )
      .set(".logo-black", {
        display: "none",
      })
      .set(".logo-light", {
        display: "block",
      })
      .fromTo(
        ".overlay",
        0.8,
        {
          top: "-100vh",
        },
        {
          top: 0,
          ease: Expo.easeInOut,
        }
      )

      .staggerFrom(
        ".menu ul li a span",
        0.6,
        {
          y: 50,
          opacity: 0,
          left: 30,
          ease: Expo.easeOut,
        },
        0.03
      );

    this.mbtl = mbtl;
  }

  public menuClose(): void {
    let d: any = document;
    let menuBtn = d.querySelector(".menu-btn");
    let logolight = d.querySelector(".logo-light");
    let logoblack = d.querySelector(".logo-black");
    let overlays = d.querySelector(".overlay");
    this.mbtl.progress(1).reverse();
    //var targetElement = document.getElementById("targetElement");
    setTimeout(() => {
      TweenMax.killAll(false, true, false);
      TweenMax.set(".menu ul li a span", {
        clearProps: "all",
      });
    }, 2000);
    setTimeout(() => {
      TweenMax.set(".logo-black", {
        display: "block",
      });
      TweenMax.set(".logo-light", {
        display: "none",
      });
      // TweenMax.set('body', { position: "block"});
    }, 1750);
  }

  public menuOpen(el: any, done: any): void {
    let d: any = document;
    let menuBtn = d.querySelector(".menu-btn");
    let logolight = d.querySelector(".logo-light");
    let logoblack = d.querySelector(".logo-black");
    let overlays = d.querySelector(".overlay");
    this.mbtl.progress(0).play();
  }

  public navHandler() {
    //  let newOffset = window.scrollY || window.pageYOffset;
    let d: any = document;
    const bannerWrapper = d.querySelector(".main-navigation");
    const banner = d.querySelector(".nav-wrap");
    let scrollpos = window.scrollY;
    bannerWrapper.style.backgroundColor = "#f7f5f0";
    if (scrollpos > 80) {
      bannerWrapper.style.backgroundColor = "#f7f5f0";
      // console.log("this if");
    } else {
      // console.log("this else");
      banner.style.backgroundColor = "transparent";
    }
  }

  @Watch("pageTitle")
  public handlePageTitleChange(val: any, oldVal: any) {
    document.title = val;
  }

  @Watch("preloaderLoaded")
  handlePreloaderLoaded(val: any, oldVal: any) {
    if (val && !this.MenuLoaded) {
      //console.log("menuAnimation")
      this.menuAnimation();
    }
  }

  public addclass() {
    let d: any = document;
    let nav = d.querySelector(".main-navigation");
    let navlist = d.querySelector(".nav-list");
    nav.classList.add("visible");
    navlist.classList.add("visible");
  }
  // getProjects(): any {
  //   axios.get(`${API_URL}/others/settings/project/`).then(({ data }) => {
  //     setTimeout(() => {
  //       this.projects = data;
  //     }, 200);
  //   });
  // }
  // public created() {
  //   if (this.$route.params.pathMatch == "projects") {
  //     this.isProject = true;
  //   } else {
  //     this.isProject = false;
  //   }
  // }

  async getMenus() {
    await this[FETCH_MAIN_MENU]();
    await this[FETCH_PROJECT_SETTINGS]();
  }

  mounted() {
    document.title = this.pageTitle;
    // this.getProjects();
    // new SmoothScroll();
    this.getMenus();
    this.mobileMenu();
    setTimeout(() => {
      this.addclass();
    }, 6000);
    this[FETCH_SOCIAL]();
    this.navHandler();
    // if (this.$route.params.pathMatch == "projects") {
    //   this.isProject = true;
    // } else {
    //   this.isProject = false;
    // }
  }

  menuAnimation() {
    let tl2 = new TimelineMax({
      onComplete: () => {
        this[SET_MENU_LOADED](true);
      },
    });
    tl2

      .to(
        "nav",
        0.01,
        {
          visibility: "visible",
        },
        "-=.5"
      )
      .to(
        ".main-navigation .nav-wrap .navbar-collapse .nav-list ",
        0.01,
        {
          visibility: "visible",
        },
        "-=.5"
      )
      .from(
        ".navbar-header",
        0.8,
        {
          yPercent: -10,
          scale: 0.9,
          duration: 2,
          autoAlpha: 0,
          opacity: 0,
          ease: Sine.easeOut,
        },
        "-=.1"
      )
      .staggerFromTo(
        ".nav-list-item",
        0.6,
        {
          yPercent: -10,
          opacity: 0,
          ease: Power1.easeOut,
        },
        {
          yPercent: 0,
          opacity: 1,
          ease: Power1.easeOut,
          clearProps: "all",
        },
        0.15,
        "-=0.2"
      );
  }

  preload(): void {
    document.body.style.height = "initial";
    let tl1 = new TimelineMax({
      onComplete: () => {
        this[SET_PRELOADER_LOADED](true);
      },
      paused: true,
    });

    tl1
      .from(".loading-logo", 0.6, {
        autoAlpha: 0,
        y: 40,
        delay: 0.6,
        opacity: 0,
        visibility: "visible",
      })
      .from("path", 0.8, {
        autoAlpha: 0,
        y: 40,
        ease: Power3.easeOut,
        opacity: 0,
      })

      .fromTo(
        "#loodingwrap",
        1,
        {
          background: "#a2875c",
          xPercent: -100,
        },
        {
          xPercent: 0,
          clearProps: "all",
        }
      )
      .to("#loodingwrap", 0.1, {
        background: "#3a3a3a",
      })
      .from(
        "path",
        0.3,
        {
          autoAlpha: 0,
          opacity: 0,
        },
        "+=.2"
      )
      .to(
        ".loading",
        1,
        {
          y: "-100%",
          ease: Power4.easeOut,
        },
        "-=.3"
      );

    tl1.play();
  }

  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (vm.mobileMenuToggle) {
        vm.mobileMenuToggle = false;
      }
    });
  }

  beforeRouteUpdate(to: any, from: any, next: any) {
    if (this.mobileMenuToggle) {
      this.mobileMenuToggle = false;
    }
    next();
  }
}
